module.exports = __webpack_public_path__ + "static/img/product2-3.5e15b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product2-3.jpg
// module id = z/VO
// module chunks = 0